import type { IssueMetadata } from '../../unit-meta/issuance.js';
import { baselineCarbonIntensityToNumber } from '../../unit-meta/product.js';

export const calculateLcaToBaseline = (metadata: IssueMetadata, equationResult: number) => {
  return (1 - equationResult / baselineCarbonIntensityToNumber(metadata.product.jetFuelBaselineCarbonIntensity));
};
